import { Modal } from "react-bootstrap";

export function ResponsibleGamingModal({ styleCss, ...props }) {
    const { onHide } = props;
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={styleCss + `-color`}
            centered
        >
            <Modal.Body className={"p-0"}>
                <div className="card card-user shadow-lg">
                    <div className="card-body p-4">
                        <h4 className="card-title text-sm text-left">Responsible Gaming</h4>
                        <p><strong>Last updated: June 2023</strong></p>

                        <p>Please read this information carefully for your own benefit. <br /> <br />
                            degencoinflip.com is operated by OG Labs N.V., having its office at Zuikertuintjeweg (Zuikertuin Tower), Willemstad, Curacao. <br />
                            Company Registration number 163351.</p>

                        <h6>Interpretation</h6>
                        <p>The words of which the initial letter is capitalized have meanings defined under the following conditions.<br />
                            The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

                        <h6>Definitions</h6>
                        <p>For the purposes of these Terms and Conditions:</p>
                        <ul>
                            <li>Account means a unique account created for You to access our Service or parts of our Service.</li>
                            <li>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Curacao Co</li>
                            <li>Service refers to the Website.</li>
                            <li>Website refers to degencoinflip.com.</li>
                            <li>You refers to the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
                        </ul>

                        <h6>Responsible Gambling and Self Exclusion</h6>
                        <p>Gambling means for the majority of our Users, entertainment, fun and excitement. But we also know that for some of our Users gambling has negative side effects. In the medical science is pathologic gambling since many years as serious sickness recognised.  Since our first day we think about this problematic and try out best to help. Under &ldquo;Responsible Gambling&rdquo; We understand multiple steps of measures, with which a gambling provider can help to lower the possibility of negative side effects appearing. -In case they already appear we also try to take active steps against them.  The most important instrument against negative side effects from gambling are knowledge and education about the risks of gambling too support our Users self-control in order to make sure they do not suffer from negative side effects.</p>

                        <h6>Information and contact</h6>
                        <p>Our Support will help you via email at any time without any additional costs for you:<br />
                            email: degencoinflipinbox@proton.me<br />
                            Our Support will of course not give out any information about You without Your consent to anyone else<br />
                            In addition you also can take a self-test, if You are already gambling addicted at: <a href="https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/">here</a><br />
                            And you can also find additional information about gambling addictions at: <a href="https://www.begambleaware.org/safer-gambling/">here</a></p>

                        <h6>Helpful hints for responsible gambling at degencoinflip.com</h6>
                        <p>We recommend you think about the following hints, before gambling to insure gambling stays fun for You and without any negative side effects:</p>
                        <ul>
                            <li>Set yourself a deposit limit</li>
                            <li>Do not try to win back a loss at every cost</li>
                            <li>Set yourself a time limit</li>
                            <li>Play smart:</li>
                            <li>Take breaks:</li>
                            <li>Only one account:</li>
                        </ul>

                        <h6>Minor Protection</h6>
                        <p>To use our Service, you must be 18 years or older. To avoid abuse, keep your login data safe from any minors near you.<br />
                            Principally we recommend a filter program to avoid minors, especially children, to access any context on the internet, which is not healthy for them.<br />
                            For parents we can recommend a list of internet filters, to support them, from keeping their children from any context, which was not made for them: <a href="https://famisafe.wondershare.com/internet-filter/best-internet-filters.html">here</a></p>

                        <h6>Self-Exclusion:</h6>
                        <p>In case You are diagnosed with a gambling addiction or try to stay away from gambling for a different reason, we want to assist you to stay away from anything, that does nothing good for you. “Self-Exclusion” means, that You exclude yourself, out of Your own choice, from all gambling services. This exclusion cannot be undone for a set amount of time. If you wish to self-exclude yourself from gambling, please message our support and give them a time span between 6 months and 5 years. They also will explain you all future steps and what is needed from you.<br />
                            email: degencoinflipinbox@proton.me<br />
                            Please keep in mind that Self Exclusion is permanent for the set time span and will not be undone for your own protection.<br />
                            During Self Exclusion you are not allowed to create a new Account and every attempt to create a new Account during Self Exclusion is a violation of our Terms of Service and may result in the permanent ban of your original account.</p>









                    </div>
                    <div className="card-footer">
                        <button className="btn btn-block w-100 btn-lg my-2 rounded-0 btn-warning" onClick={onHide}>GOT IT</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
